
  <mb-dialog-header>
    <h3
      class="mb-dialog-custom__header text"
      i18n="@@modals_disneyclustermealsinfo_suma_tu_plan_de_comida"
    >
      Sumá tu plan de comida
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <section
        *ngFor="let currentRate of filteredRates | keyvalue: descOrder; let i = index"
      >
        <div class="meal-description mb-col-8">
          <div *ngIf="currentRate.key === 'DISNEY_QUICK_DINING'">
            <h6 i18n="@@modals_disneyclustermealsinfo_plan_de_comidas_rapidas">
              Plan de comidas rápidas
            </h6>
            <p i18n="@@modals_disney_cluster_meals_plan_de_comidas_rapidas_intro">
              Comerás en lugares de servicio rápido, ideales para descansar y disfrutar de
              una comida informal. Cuando sea la hora de comer algo, tan solo haz tu
              pedido en el mostrador o la caja, y luego encuentra un lugar para sentarte.
              <strong>Este servicio incluye:</strong>
            </p>
            <div *ngIf="toggleStatus[i]">
              <ul>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_2_dos_comidas_de_servicio_rapido_incluye_plato_principal_y_bebida_sin_alcohol_comida_estilo_combo_a_ser_canjeada_en_restaurantes_de_servicio_rapido"
                    ><strong>2 (dos) Comidas de Servicio Rápido:</strong> incluye plato
                    principal y bebida sin alcohol. Comida estilo combo, a ser canjeada en
                    restaurantes de servicio rápido.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_2_dos_Snacks_que_corresponde_a_un_helado_una_caja_de_popcorn_una_fruta_o_un_refresco_mediano_o_jugo"
                    ><strong>2 (dos) Snacks:</strong> que corresponde a un helado, una
                    caja de popcorn, una fruta o un refresco mediano o jugo.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_un_jarro_recargable_de_bebidas_por_persona_por_paquete"
                    ><strong>Un jarro recargable de bebidas:</strong> por persona, por
                    paquete.</span
                  >
                </li>
              </ul>
              <p i18n="@@modals_disneyclustermealsinfo_importante">Importante</p>
              <ul class="importante">
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_por_persona_por_todos_los_dias_de_la_estadia_por_ejemplo_5_noches_de_estadia_incluyen_5_dias_de_comidas"
                >
                  Por persona, por todos los días de la estadía. Por ejemplo: 5 noches de
                  estadía incluyen 5 días de comidas.
                </li>
                <li
                  i18n="@@modals_disneyclustermealsinfo_las_propinas_no_estan_incluidas"
                >
                  Las propinas no están incluidas.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_los_ninos_entre_39_anos_deben_elegir_del_menu_para_ninos_en_el_caso_que_este_disponible"
                >
                  Los niños entre 3-9 años deben elegir del menú para niños, en el caso
                  que esté disponible.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_las_comidas_no_son_transferibles_entre_personas_del_grupo_y_vencen_a_la_media_noche_de_la_fecha_de_salida"
                >
                  Las comidas no son transferibles entre personas del grupo y vencen a la
                  media noche de la fecha de salida.
                </li>
              </ul>
            </div>
            <div class="view-more" (click)="toggle(i)">
              <span i18n="@@ver_detalle" *ngIf="!toggleStatus[i]">Ver detalle</span>
              <span i18n="@@ocultar_detalle" *ngIf="toggleStatus[i]"
                >Ocultar detalle</span
              >
              <mb-icon *ngIf="toggleStatus[i]" class="icon icon-up" icon="up"></mb-icon>
              <mb-icon
                *ngIf="!toggleStatus[i]"
                class="icon icon-down"
                icon="down"
              ></mb-icon>
            </div>
          </div>
          <div *ngIf="currentRate.key === 'DISNEY_DINING'">
            <h6 i18n="@@modals_disneyclustermealsinfo_plan_de_comida_basico">
              Plan de comida básico
            </h6>
            <p i18n="@@modals_disney_cluster_meals_plan_de_comida_basico_intro">
              Espera la atención en más de 50 restaurantes con servicio de mesa a
              elección. Deléitate con un servicio incomparable y una cocina gourmet con un
              toque mágico de Disney, además de disfrutar de comidas para llevar y snacks.
              <strong>Este servicio incluye:</strong>
            </p>
            <div *ngIf="toggleStatus[i]">
              <ul>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_1_una_comida_de_servicio_a_la_mesa_incluye_plato_principal_postre_y_bebida_sin_alcohol_o_un_buffet_completo"
                    ><strong>1 (una) Comida de Servicio a la mesa:</strong> incluye plato
                    principal, postre y bebida sin alcohol o un buffet completo.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_1_una_comida_de_servicio_rapido_incluye_plato_principal_y_bebida_sin_alcohol_comida_estilo_combo_a_ser_canjeada_en_restaurantes_de_servicio_rapido"
                    ><strong>1 (una) Comida de Servicio Rápido:</strong> incluye plato
                    principal y bebida sin alcohol. Comida estilo combo, a ser canjeada en
                    restaurantes de servicio rápido.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_2_dos_Snacks_que_corresponde_a_un_helado_una_caja_de_popcorn_una_fruta_o_un_refresco_mediano_o_jugo"
                    ><strong>2 (dos) Snacks:</strong> que corresponde a un helado, una
                    caja de popcorn, una fruta o un refresco mediano o jugo.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_un_jarro_recargable_de_bebidas_por_persona_por_paquete"
                    ><strong>Un jarro recargable de bebidas:</strong> por persona, por
                    paquete.</span
                  >
                </li>
              </ul>
              <p i18n="@@modals_disneyclustermealsinfo_importante">Importante</p>
              <ul class="importante">
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_por_persona_por_todos_los_dias_de_la_estadia_por_ejemplo_5_noches_de_estadia_incluyen_5_dias_de_comidas"
                >
                  Por persona, por todos los días de la estadía. Por ejemplo: 5 noches de
                  estadía incluyen 5 días de comidas.
                </li>
                <li
                  i18n="@@modals_disneyclustermealsinfo_las_propinas_no_estan_incluidas"
                >
                  Las propinas no están incluidas.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_los_ninos_entre_39_anos_deben_elegir_del_menu_para_ninos_en_el_caso_que_este_disponible"
                >
                  Los niños entre 3-9 años deben elegir del menú para niños, en el caso
                  que esté disponible.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_las_comidas_no_son_transferibles_entre_personas_del_grupo_y_vencen_a_la_media_noche_de_la_fecha_de_salida"
                >
                  Las comidas no son transferibles entre personas del grupo y vencen a la
                  media noche de la fecha de salida.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_debido_a_la_concurrencia_a_los_restaurantes_con_servicio_de_mesa_la_disponibilidad_puede_ser_limitada_o_no_estar_disponible_si_no_reservaste_con_anticipacion"
                >
                  Debido a la concurrencia a los restaurantes con servicio de mesa, la
                  disponibilidad puede ser limitada o no estar disponible si no reservaste
                  con anticipación.
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_detalles_de_intercambio_de_derecho_de_comida_2_dos_comidas_con_servicio_de_mesa_por_persona_puede_ser_cambiada_por_una_comida_con_personajes_o_una_comida_en_la_habitacion"
                    ><strong>Detalles de intercambio de derecho de comida:</strong> 2
                    (dos) comidas con servicio de mesa por persona puede ser cambiada por
                    una comida con personajes o una comida en la habitación.</span
                  >
                </li>
              </ul>
            </div>
            <div class="view-more" (click)="toggle(i)">
              <span i18n="@@ver_detalle" *ngIf="!toggleStatus[i]">Ver detalle</span>
              <span i18n="@@ocultar_detalle" *ngIf="toggleStatus[i]"
                >Ocultar detalle</span
              >
              <mb-icon *ngIf="toggleStatus[i]" class="icon icon-up" icon="up"></mb-icon>
              <mb-icon
                *ngIf="!toggleStatus[i]"
                class="icon icon-down"
                icon="down"
              ></mb-icon>
            </div>
          </div>
          <div *ngIf="currentRate.key === 'DISNEY_DELUXE'">
            <h6 i18n="@@modals_disneyclustermealsinfo_plan_de_comida_de_lujo">
              Plan de comida de lujo
            </h6>
            <p i18n="@@modals_disney_cluster_meals_plan_de_comida_de_lujo_intro">
              Haz que tu experiencia culinaria sea una para recordar, desde el primero
              hasta el último bocado, con este completo plan de comidas que ofrece comidas
              y aperitivos deliciosos, además de exquisitos snacks.
              <strong>Este servicio incluye:</strong>
            </p>
            <div *ngIf="toggleStatus[i]">
              <ul>
                <li>
                  <strong
                    i18n="
                      @@modals_disneyclustermealsinfo_3_tres_comidas_a_eleccion_entre_restaurantes_con_servicios_de_mesa_o_de_comida_rapida"
                    >3 (tres) comidas a elección entre restaurantes con servicios de mesa
                    o de comida rápida.</strong
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_2_dos_Snacks_que_corresponde_a_un_helado_una_caja_de_popcorn_una_fruta_o_un_refresco_mediano_o_jugo"
                    ><strong>2 (dos) Snacks:</strong> que corresponde a un helado, una
                    caja de popcorn, una fruta o un refresco mediano o jugo.</span
                  >
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_un_jarro_recargable_de_bebidas_por_persona_por_paquete"
                    ><strong>Un jarro recargable de bebidas:</strong> por persona, por
                    paquete.</span
                  >
                </li>
              </ul>
              <p i18n="@@modals_disneyclustermealsinfo_importante">Importante</p>
              <ul class="importante">
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_por_persona_por_todos_los_dias_de_la_estadia_por_ejemplo_5_noches_de_estadia_incluyen_5_dias_de_comidas"
                >
                  Por persona, por todos los días de la estadía. Por ejemplo: 5 noches de
                  estadía incluyen 5 días de comidas.
                </li>
                <li
                  i18n="@@modals_disneyclustermealsinfo_las_propinas_no_estan_incluidas"
                >
                  Las propinas no están incluidas.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_los_ninos_entre_39_anos_deben_elegir_del_menu_para_ninos_en_el_caso_que_este_disponible"
                >
                  Los niños entre 3-9 años deben elegir del menú para niños, en el caso
                  que esté disponible.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_las_comidas_no_son_transferibles_entre_personas_del_grupo_y_vencen_a_la_media_noche_de_la_fecha_de_salida"
                >
                  Las comidas no son transferibles entre personas del grupo y vencen a la
                  media noche de la fecha de salida.
                </li>
                <li
                  i18n="
                    @@modals_disneyclustermealsinfo_debido_a_la_concurrencia_a_los_restaurantes_con_servicio_de_mesa_la_disponibilidad_puede_ser_limitada_o_no_estar_disponible_si_no_reservaste_con_anticipacion"
                >
                  Debido a la concurrencia a los restaurantes con servicio de mesa, la
                  disponibilidad puede ser limitada o no estar disponible si no reservaste
                  con anticipación.
                </li>
                <li>
                  <span
                    i18n="
                      @@modals_disneyclustermealsinfo_detalles_de_intercambio_de_derecho_de_comida_2_dos_comidas_con_servicio_de_mesa_por_persona_puede_ser_cambiada_por_una_comida_con_personajes_o_una_comida_en_la_habitacion"
                    ><strong>Detalles de intercambio de derecho de comida:</strong> 2
                    (dos) comidas con servicio de mesa por persona puede ser cambiada por
                    una comida con personajes o una comida en la habitación.</span
                  >
                </li>
              </ul>
            </div>
            <div class="view-more" (click)="toggle(i)">
              <span i18n="@@ver_detalle" *ngIf="!toggleStatus[i]">Ver detalle</span>
              <span i18n="@@ocultar_detalle" *ngIf="toggleStatus[i]"
                >Ocultar detalle</span
              >
              <mb-icon *ngIf="toggleStatus[i]" class="icon icon-up" icon="up"></mb-icon>
              <mb-icon
                *ngIf="!toggleStatus[i]"
                class="icon icon-down"
                icon="down"
              ></mb-icon>
            </div>
          </div>
        </div>
        <div class="meal-price mb-col-3 mb-col-offset-1">
          <div *ngIf="currentRate.value.rate">
            <div *ngIf="!isMealPlanFree(currentRate.value.rate)">
              <span class="price-description">
                <span i18n="@@precio_precio_por_habitacion_por_noche_para_x"
                  >Precio <strong>por habitación</strong>, por <strong>noche</strong> para
                  {{ quantityGuests }}</span
                >
                <strong i18n="@@persona_personas">{quantityGuests, plural,
                  =1 {persona}
                  other {personas}
                }</strong>
              </span>
              <div class="price">
                <strong *ngIf="currentRate.value.rate">
                  {{ getRateSupplement(currentRate.value.rate, 'MEAL').currency.code }}
                  {{
                    getRateSupplement(currentRate.value.rate, 'MEAL')
                      .amount_per_night_per_room | Currency
                  }}
                </strong>
              </div>
            </div>
          </div>
          <div class="price" *ngIf="currentRate.value.rate">
            <strong i18n="@@gratis" *ngIf="isMealPlanFree(currentRate.value.rate)"
              >¡GRATIS!</strong
            >
          </div>
          <div class="price">
            <strong
              *ngIf="!currentRate.value.rate"
              i18n="@@modals_disneyclustermealsinfo_plan_no_disponible"
              >Plan no disponible</strong
            >
          </div>
          <button
            *ngIf="currentRate.value.rate"
            mb-button
            mb-button-fullwidth
            variant="principal"
            color="primary"
            i18n="@@modals_disneyclustermealsinfo_sumar_plan"
            (click)="closeDialog(currentRate.value.mealPlan)"
          >
            Sumar plan
          </button>
          <button
            *ngIf="!currentRate.value.rate"
            mb-button
            mb-button-fullwidth
            variant="principal"
            color="primary"
            [disabled]="true"
            i18n="@@no_disponible"
          >
            No disponible
          </button>
        </div>
      </section>
    </div>
  </mb-dialog-body>
